import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ListBox } from "primereact/listbox";

export default function NoteEditor({ results, setResults }) {
  const [newNote, setNewNote] = useState("");
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [removeIndex, setRemoveIndex] = useState(null);

  const removeNote = (index) => {
    const updated = results.notes.filter((_, i) => i !== index);
    const newResults = { ...results, notes: updated };
    setResults(newResults); // plain object, works with your wrapper
  };

  const addNote = () => {
    if (!newNote.trim()) return;

    const newId = String(Date.now());

    const addedNote = { id: newId, name: newNote.trim() };

    const newResults = {
      ...results,
      notes: [...results.notes, addedNote],
    };

    setResults(newResults); // plain object, works with your wrapper
    setNewNote(""); // clear input
  };

  const noteTemplate = (note) => {
    const index = results.notes.findIndex((p) => p.id === note.id);

    return (
      <div
        className="p-d-flex p-jc-between p-ai-center"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>{note.name}</span>
        <Button
          icon="pi pi-times"
          className="p-button-text p-button-sm"
          onClick={() => {
            setRemoveIndex(index);
            setConfirmVisible(true);
          }}
        />
      </div>
    );
  };

  return (
    <div>
      <ListBox
        value={results.notes}
        options={results.notes}
        optionLabel="name"
        itemTemplate={noteTemplate}
        emptyMessage="Ei kirjauksia"
        style={{ width: "100%", "margin-top": "20px" }}
      />

      <div style={{ display: "flex", gap: "0.5rem", marginTop: "1rem" }}>
        <div className="p-inputgroup flex-1">
          <InputText
            placeholder=""
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && addNote()}
            style={{ flexGrow: 1 }}
          />
          <Button
            label=""
            icon="pi pi-plus"
            className="p-button-outlined p-button-sm"
            onClick={addNote}
          />
        </div>
      </div>
      <Dialog
        header="Vahvista poisto"
        visible={confirmVisible}
        onHide={() => setConfirmVisible(false)}
        dismissableMask
        footer={
          <div>
            <Button
              label="Poista"
              icon="pi pi-check"
              severity="danger"
              onClick={() => {
                removeNote(removeIndex);
                setConfirmVisible(false);
              }}
              autoFocus
            />
            <Button
              label="Peruuta"
              icon="pi pi-times"
              onClick={() => setConfirmVisible(false)}
              className="p-button-text"
            />
          </div>
        }
      >
        {removeIndex != null && (
          <>
            Poistetaanko <b>{results.notes[removeIndex]?.name}</b>?
          </>
        )}
      </Dialog>
    </div>
  );
}
